<template>
  <div class="gx-modal" @click.self="close">
    <div class="gx-modal-box gx-wdb__box">
      <div class="gx-modal-head gx-modal-head--gray">
        <span class="gx-modal-title">店铺详情 · {{ shopName }}</span>
        <button class="gx-modal-close" @click="close">✕</button>
      </div>
      <div class="gx-modal-body gx-wdb__body">
        <!-- 时间筛选 -->
        <div class="gx-wdb__filter">
          <span class="gx-wdb__label">时间：</span>
          <span
            v-for="item in timeOptions"
            :key="item.id"
            class="gx-wdb__time-tag"
            :class="{ active: timeSelectId === item.id }"
            @click="timeTagClick(item)"
          >{{ item.name }}</span>
          <el-date-picker
            v-model="displayDateRange"
            type="daterange"
            range-separator="-"
            size="small"
            value-format="yyyy-MM-dd"
            start-placeholder="开始"
            end-placeholder="结束"
            :picker-options="datePickerOptions"
            style="width:220px;margin-left:10px;"
            @change="customDateChange"
          />
        </div>

        <!-- 一级标签 -->
        <div class="gx-wdb__main-tabs">
          <span class="gx-wdb__main-tab" :class="{ active: mainTab === 'transaction' }" @click="switchMainTab('transaction')">成交数据</span>
          <span class="gx-wdb__main-tab" :class="{ active: mainTab === 'refund' }" @click="switchMainTab('refund')">退款数据</span>
        </div>

        <div v-loading="loading" class="gx-wdb__content">
          <!-- 成交数据：概览卡片 + 成交分析表格 -->
          <template v-if="mainTab === 'transaction'">
            <div class="gx-wdb__section-title">成交概览</div>
            <div class="gx-wdb__cards">
              <div v-for="field in overviewFields" :key="field.key" class="gx-wdb__card">
                <div class="gx-wdb__card-label">{{ field.label }}</div>
                <div class="gx-wdb__card-value">{{ formatValue(getSummaryData(field.key), field.fmt) }}</div>
              </div>
            </div>
            <div class="gx-wdb__section-title">成交分析</div>
            <el-table :data="getTableData('18')" border size="small" style="width:100%">
              <el-table-column
                v-for="col in transactionColumns"
                :key="col.key"
                :prop="col.key"
                :label="col.label"
                :width="col.width"
                :min-width="col.minWidth"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ col.key === 'statistical_time' ? (scope.row[col.key] || rangeText) : formatValue(scope.row[col.key], col.fmt) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>

          <!-- 退款数据：三个退款分析子标签 -->
          <template v-else>
            <div class="gx-wdb__sub-tabs">
              <span
                v-for="tab in refundSubTabs"
                :key="tab.key"
                class="gx-wdb__sub-tab"
                :class="{ active: subTab === tab.key }"
                @click="subTab = tab.key"
              >{{ tab.label }}</span>
            </div>
            <el-table :data="getTableData(subTab)" border size="small" style="width:100%">
              <el-table-column
                v-for="col in getRefundColumns(subTab)"
                :key="col.key"
                :prop="col.key"
                :label="col.label"
                :width="col.width"
                :min-width="col.minWidth"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ col.key === 'statistical_time' ? (scope.row[col.key] || rangeText) : formatValue(scope.row[col.key], col.fmt) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// 退款数据子标签
const refundSubTabs = [
  { key: '19', label: '退款分析-全部' },
  { key: '20', label: '退款分析-退款' },
  { key: '21', label: '退款分析-退货退款' }
]

// 成交概览卡片字段
const overviewFields = [
  { key: 'income_amt', label: '成交金额', fmt: 'money' },
  { key: 'net_pay_cnt', label: '成交订单数', fmt: 'num' },
  { key: 'net_pay_ucnt', label: '成交人数', fmt: 'num' },
  { key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money' },
  { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' }
]

// 成交分析表格列
const transactionColumns = [
  { key: 'statistical_time', label: '时间', width: 105, fmt: 'text' },
  { key: 'income_amt', label: '成交金额', fmt: 'money', minWidth: 100 },
  { key: 'net_pay_cnt', label: '成交订单数', fmt: 'num', minWidth: 90 },
  { key: 'net_pay_ucnt', label: '成交人数', fmt: 'num', minWidth: 90 },
  { key: 'pay_amt', label: '下单金额', fmt: 'money', minWidth: 100 },
  { key: 'pay_cnt', label: '下单订单数', fmt: 'num', minWidth: 90 },
  { key: 'pay_ucnt', label: '下单人数', fmt: 'num', minWidth: 90 },
  { key: 'refund_amt', label: '退款金额', fmt: 'money', minWidth: 100 },
  { key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money', minWidth: 110 },
  { key: 'per_user_price', label: '客单价', fmt: 'money', minWidth: 90 }
]

// 退款分析-全部 表格列
const refund19Columns = [
  { key: 'statistical_time', label: '时间', width: 105, fmt: 'text' },
  { key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money', minWidth: 110 },
  { key: 'pay_refund_success_ocnt', label: '成交退款订单数', fmt: 'num', minWidth: 120 },
  { key: 'pay_refund_success_ucnt', label: '成交退款人数', fmt: 'num', minWidth: 110 },
  { key: 'pay_refund_success_pcnt', label: '成交退款商品数', fmt: 'num', minWidth: 120 },
  { key: 'pay_refund_success_uv_rate', label: '成交退款率', fmt: 'rate', minWidth: 100 }
]

// 退款分析-退款 表格列
const refund20Columns = [
  { key: 'statistical_time', label: '时间', width: 105, fmt: 'text' },
  { key: 'ship_before_refund_amt', label: '发货前退款金额', fmt: 'money', minWidth: 120 },
  { key: 'ship_before_refund_ocnt', label: '发货前退款订单数', fmt: 'num', minWidth: 130 },
  { key: 'ship_before_refund_ucnt', label: '发货前退款人数', fmt: 'num', minWidth: 120 },
  { key: 'ship_before_refund_rate', label: '发货前退款率', fmt: 'rate', minWidth: 110 },
  { key: 'ship_after_noreceive_refund_amt', label: '发货后退款金额', fmt: 'money', minWidth: 120 },
  { key: 'ship_after_noreceive_refund_ocnt', label: '发货后退款订单数', fmt: 'num', minWidth: 130 },
  { key: 'ship_after_noreceive_refund_ucnt', label: '发货后退款人数', fmt: 'num', minWidth: 120 },
  { key: 'ship_after_noreceive_refund_rate', label: '发货后退款率', fmt: 'rate', minWidth: 110 },
  { key: 'refund_amt_rate', label: '退款金额占比', fmt: 'rate', minWidth: 110 },
  { key: 'refund_cnt_rate', label: '退款订单数占比', fmt: 'rate', minWidth: 120 }
]

// 退款分析-退货退款 表格列
const refund21Columns = [
  { key: 'statistical_time', label: '时间', width: 105, fmt: 'text' },
  { key: 'ship_after_receive_b_refund_amt', label: '退货退款金额', fmt: 'money', minWidth: 110 },
  { key: 'ship_after_receive_b_refund_ocnt', label: '退货退款订单数', fmt: 'num', minWidth: 120 },
  { key: 'ship_after_receive_b_refund_ucnt', label: '退货退款人数', fmt: 'num', minWidth: 110 },
  { key: 'ship_after_receive_b_refund_rate', label: '退货退款率', fmt: 'rate', minWidth: 110 },
  { key: 'ship_after_receive_refund_amt_rate', label: '退货退款金额占比', fmt: 'rate', minWidth: 130 },
  { key: 'ship_after_receive_refund_ocnt_rate', label: '退货退款订单数占比', fmt: 'rate', minWidth: 140 }
]

export default {
  name: 'WechatShopDetailModal',
  props: {
    shop: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      mainTab: 'transaction',
      subTab: '19',
      timeSelectId: 1,
      customDateRange: '',
      selectingStartDate: null,
      searchData: {
        start_time: '',
        end_time: ''
      },
      timeOptions: [
        { id: 1, name: '实时', day: 'realtime' },
        { id: 2, name: '近1天', day: '1' },
        { id: 3, name: '近7天', day: '7' },
        { id: 4, name: '近30天', day: '30' }
      ],
      datePickerOptions: {
        onPick: ({ minDate }) => {
          if (minDate) {
            this.selectingStartDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (time.getTime() > Date.now()) {
            return true
          }
          if (this.selectingStartDate) {
            const oneDay = 24 * 60 * 60 * 1000
            const maxDays = 31
            const minTime = this.selectingStartDate - maxDays * oneDay
            const maxTime = this.selectingStartDate + maxDays * oneDay
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return false
        }
      },
      apiData: {
        type18_data: [],
        type19_data: [],
        type20_data: [],
        type21_data: [],
        type22_data: null
      },
      overviewFields,
      transactionColumns,
      refund19Columns,
      refund20Columns,
      refund21Columns
    }
  },
  computed: {
    shopName() {
      return this.shop.shop_name || ''
    },
    refundSubTabs() {
      return refundSubTabs
    },
    isRealtimeData() {
      return this.timeSelectId === 1
    },
    rangeText() {
      const range = this.displayDateRange
      if (!range || range.length !== 2) return '--'
      return range[0] === range[1] ? range[0] : `${range[0]} ~ ${range[1]}`
    },
    displayDateRange: {
      get() {
        if (this.customDateRange && this.customDateRange.length === 2) {
          return this.customDateRange
        }
        if (this.searchData.start_time && this.searchData.end_time) {
          return [this.searchData.start_time, this.searchData.end_time]
        }
        const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId)
        if (timeOption) {
          if (timeOption.day === 'realtime') {
            const today = this.formatDate(new Date())
            return [today, today]
          }
          const today = new Date()
          const days = parseInt(timeOption.day)
          const yesterday = new Date(today)
          yesterday.setDate(yesterday.getDate() - 1)
          const end = this.formatDate(yesterday)
          const start = new Date(yesterday)
          start.setDate(start.getDate() - (days - 1))
          return [this.formatDate(start), end]
        }
        return ''
      },
      set(value) {
        this.customDateRange = value
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    ...mapActions({
      getWechatShopDataDetail: 'shop_board/getWechatShopDataDetail'
    }),
    close() {
      this.$emit('close')
    },
    switchMainTab(tab) {
      this.mainTab = tab
      this.subTab = '19'
    },
    timeTagClick(item) {
      this.timeSelectId = item.id
      this.customDateRange = ''
      this.searchData.start_time = ''
      this.searchData.end_time = ''
      this.loadData()
    },
    customDateChange() {
      this.selectingStartDate = null
      if (this.customDateRange && this.customDateRange.length === 2) {
        const start = new Date(this.customDateRange[0])
        const end = new Date(this.customDateRange[1])
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
        if (diffDays > 31) {
          this.$message.warning('时间范围不能超过31天')
          this.customDateRange = ''
          return
        }
        this.timeSelectId = ''
        this.searchData.start_time = this.customDateRange[0]
        this.searchData.end_time = this.customDateRange[1]
      } else {
        this.timeSelectId = 1
        this.searchData.start_time = ''
        this.searchData.end_time = ''
      }
      this.loadData()
    },
    loadData() {
      const merShopId = this.shop.mer_shop_id || this.shop.shop_id
      if (!merShopId) return

      this.loading = true
      const range = this.displayDateRange
      this.getWechatShopDataDetail({
        data: {
          mer_shop_id: merShopId,
          start_date: this.searchData.start_time || range[0],
          end_date: this.searchData.end_time || range[1],
          is_realtime: this.isRealtimeData ? 1 : 0
        },
        success: (res) => {
          this.loading = false
          if (res.code === 200 && res.data) {
            this.apiData = res.data
          } else {
            this.$message.error(res.msg || '获取数据失败')
          }
        },
        error: () => {
          this.loading = false
        }
      })
    },
    getSummaryData(key) {
      if (this.isRealtimeData && this.apiData.type22_data) {
        return this.apiData.type22_data[key]
      }
      if (this.apiData.type18_data && this.apiData.type18_data.length > 0) {
        if (key === 'per_user_price') {
          const totalIncome = parseFloat(this.getSummaryData('income_amt')) || 0
          const totalUsers = parseFloat(this.getSummaryData('net_pay_ucnt')) || 0
          return totalUsers > 0 ? totalIncome / totalUsers : 0
        }
        let sum = 0
        this.apiData.type18_data.forEach(row => {
          sum += parseFloat(row[key]) || 0
        })
        return sum
      }
      return 0
    },
    getTableData(type) {
      return this.apiData[`type${type}_data`] || []
    },
    getRefundColumns(type) {
      if (type === '19') return refund19Columns
      if (type === '20') return refund20Columns
      if (type === '21') return refund21Columns
      return []
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatValue(val, fmt) {
      if (val === undefined || val === null || val === '') return '--'
      if (fmt === 'money') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万'
        return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      if (fmt === 'num') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return (n / 10000).toFixed(2) + '万'
        return n.toLocaleString('zh-CN')
      }
      if (fmt === 'bignum') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return (n / 10000).toFixed(1) + '万'
        return n.toLocaleString('zh-CN')
      }
      return val
    }
  }
}
</script>

<style scoped>
.gx-wdb__box {
  max-width: 960px;
}
.gx-wdb__body {
  padding: 14px 18px 20px;
}
.gx-wdb__filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.gx-wdb__label {
  color: #606266;
  font-size: 13px;
  margin-right: 6px;
}
.gx-wdb__time-tag {
  display: inline-block;
  padding: 4px 12px;
  margin-right: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  transition: all .2s;
  user-select: none;
}
.gx-wdb__time-tag:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F5;
}
.gx-wdb__time-tag.active {
  color: #fff;
  background: #C8443C;
  border-color: #C8443C;
}
.gx-wdb__main-tabs {
  display: flex;
  gap: 26px;
  border-bottom: 2px solid #E4E7ED;
  margin-top: 14px;
}
.gx-wdb__main-tab {
  padding: 9px 2px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all .2s;
  user-select: none;
}
.gx-wdb__main-tab:hover {
  color: #C8443C;
}
.gx-wdb__main-tab.active {
  color: #C8443C;
  border-bottom-color: #C8443C;
  font-weight: 600;
}
.gx-wdb__content {
  min-height: 240px;
  padding-top: 14px;
}
.gx-wdb__section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.gx-wdb__cards {
  display: flex;
  align-items: stretch;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.gx-wdb__card {
  flex: 1 1 0;
  min-width: 140px;
  background: #FAFBFC;
  border: 1px solid #EBEEF5;
  border-radius: 6px;
  padding: 12px 10px;
  text-align: center;
}
.gx-wdb__card-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  white-space: nowrap;
}
.gx-wdb__card-value {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}
.gx-wdb__sub-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}
.gx-wdb__sub-tab {
  padding: 5px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  transition: all .2s;
  user-select: none;
}
.gx-wdb__sub-tab:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F5;
}
.gx-wdb__sub-tab.active {
  color: #fff;
  background: #C8443C;
  border-color: #C8443C;
}
</style>
